import { render } from "./FinishedTestsList.vue?vue&type=template&id=bc4d21b2"
import script from "./FinishedTestsList.vue?vue&type=script&lang=js"
export * from "./FinishedTestsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__